import React, { useMemo, useCallback } from 'react'
import { DateBox } from 'devextreme-react'
import { Button as DateBoxButton } from 'devextreme-react/date-box'
import { ValueChangedEvent } from 'devextreme/ui/date_box'
import { Duration } from 'luxon'

interface DurationInputProps {
  value?: string // ISO duration string like "PT4H"
  onChange: (value: string) => void
  onBlur?: () => void
  readOnly?: boolean
  label?: string
  name?: string
}

const minSpanDate = new Date(0, 0, 0, 0, 0)
const maxSpanDate = new Date(0, 0, 0, 10, 0)

export const DurationInput: React.FC<DurationInputProps> = ({
  value,
  onChange,
  onBlur,
  readOnly = false,
  label,
  name,
}) => {
  // Convert ISO duration to Date for display
  const dateValue = useMemo(() => {
    if (!value) return new Date(0, 0, 0, 0, 0)

    try {
      const duration = Duration.fromISO(value)
      const hours = Math.floor(duration.as('hours'))
      const minutes = Math.floor((duration.as('hours') - hours) * 60)
      return new Date(0, 0, 0, hours, minutes)
    } catch {
      return new Date(0, 0, 0, 0, 0)
    }
  }, [value])

  // Convert Date to ISO duration and trigger onChange
  const handleValueChange = useCallback(
    (e: ValueChangedEvent) => {
      if (!e.value) return

      const duration = Duration.fromObject({
        hours: e.value.getHours(),
        minutes: e.value.getMinutes(),
      })

      onChange(duration.toISO())
    },
    [onChange],
  )

  // Handle increment/decrement buttons
  const adjustTime = useCallback(
    (minutes: number) => {
      const currentMinutes = dateValue.getHours() * 60 + dateValue.getMinutes()
      const newMinutes = Math.max(0, Math.min(600, currentMinutes + minutes)) // Max 10 hours

      const hours = Math.floor(newMinutes / 60)
      const mins = newMinutes % 60

      const duration = Duration.fromObject({ hours, minutes: mins })
      onChange(duration.toISO())
    },
    [dateValue, onChange],
  )

  return (
    <div className="duration-input">
      <DateBox
        readOnly={readOnly}
        value={dateValue}
        type="time"
        min={minSpanDate}
        max={maxSpanDate}
        pickerType="native"
        interval={15}
        displayFormat={'HH:mm'}
        onValueChanged={handleValueChange}
        onFocusOut={onBlur}
        name={name}
      >
        {/* <DateBoxButton
          name="increment"
          location="after"
          options={{
            icon: 'plus',
            stylingMode: 'text',
            onClick: () => adjustTime(15),
          }}
        />
        <DateBoxButton
          name="decrement"
          location="after"
          options={{
            icon: 'minus',
            stylingMode: 'text',
            onClick: () => adjustTime(-15),
          }}
        /> */}
        {/* <DateBoxButton name="dropDown" /> */}
      </DateBox>
    </div>
  )
}
